import moment from "moment";

export default function formatDate(datetime) {
  const m = moment(datetime);
  return m.isValid() ? m.format("YYYY-MM-DD") : "";
}
